export default __webpack_public_path__ + "static/media/26.2633a20a.jpg";